import React, { useState } from "react"
import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import { Typography, message, Spin } from "antd"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"

const { Link } = Typography

export default function MarkReadyForPrint({ record }) {
  const [loading, setLoading] = useState(false)

  const toggleReady = async () => {
    if (!record || !record.id) return

    setLoading(true)
    try {
      const orderRef = doc(db, "orders", record.id)
      await updateDoc(orderRef, {
        readyForPrinting: !record.readyForPrinting,
      })
      message.success(
        `Order ${record.orderNumber} marked ${
          record.readyForPrinting ? "not ready" : "ready"
        } for printing.`
      )
    } catch (err) {
      console.error(err)
      message.error("Failed to update print status. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      {loading ? (
        <Spin size="small" />
      ) : (
        <Link onClick={toggleReady} style={{ cursor: "pointer" }}>
          {record && record.readyForPrinting ? (
            <CheckOutlined style={{ color: "#52c41a" }} />
          ) : (
            <CloseOutlined style={{ color: "#f5222d" }} />
          )}
        </Link>
      )}
    </div>
  )
}
